import { DEFAULT_RATING_DATA } from '../../../common/constants/constants'

export const trustpilotData = {
  trustScore: parseFloat(DEFAULT_RATING_DATA?.ratingValue),
  trustReviewsTotal: parseInt(DEFAULT_RATING_DATA?.reviewCount),
  trustCountry: 'US',
}
